import { FC } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { getMediaLogo } from '../../utils/file';
import { useTranslation } from 'react-i18next';
import { CampaignMode, CampaignType, Media } from '../../interfaces/campaign';
import { isCampaignAdvertisingType, isCampaignCreateMode } from '../../utils/string';
import usePlatformCardColors from '../../hooks/usePlatformCardColors';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';

type ISocialBox = {
	platform: Media;
	platformId: number;
	selected: boolean;
	dimmed: boolean;
	mode: CampaignMode;
	onChange: (platform: Media, platformId: number, checked: boolean) => void;
};

const SocialBox: FC<ISocialBox> = ({ platform, selected, dimmed, mode, platformId, onChange }) => {
	const { type } = useParams<{ type: string }>();
	const isAdvertising = isCampaignAdvertisingType(type as CampaignType);
	const { t } = useTranslation();

	const isCreateMode = isCampaignCreateMode(mode);
	const { title, borderColorClass, checkedColorClass } = usePlatformCardColors(platform);

	const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		onChange(platform, platformId, event.target.checked);
	};

	const boxBaseClasses = `transform transition-all duration-1000 ease-in-out flex h-32 w-40 flex-col items-center justify-center rounded-lg`;
	const boxShadowClass = isCreateMode ? 'shadow-md' : 'shadow-none';
	const isApplication = platform === 'app';
	const isAdvertisingFilter = !isAdvertising && (platform === 'sms' || platform === 'media_growth');
	const boxBorderClass = clsx({
		[borderColorClass]: !dimmed && selected,
		// 'border-0': dimmed && !selected,
	});

	const boxBackgroundClass = clsx({
		'bg-grey-100 mix-blend-luminosity': dimmed && !selected,
		'bg-transparent': !dimmed && isCreateMode && selected,
	});

	const checkboxClass = clsx({
		[checkedColorClass]: selected && isCreateMode,
		'm-0': true,
	});

	return (
		<Box className={clsx(boxBaseClasses, boxShadowClass, boxBorderClass, boxBackgroundClass)}>
			<img src={getMediaLogo(platform)} alt={`${platform} logo`} className="h-12 w-12" aria-label={`${platform} logo`} />
			<FormControlLabel disabled={!isCreateMode || isApplication || isAdvertisingFilter} control={<Checkbox checked={selected} onChange={handleCheckBoxChange} className={checkboxClass} />} label={t(title)} />
		</Box>
	);
};

export default SocialBox;
